import { Table } from '@tanstack/react-table';
import { UseFormReturn } from 'react-hook-form';

import {
  GenerateEntityFooter,
  GenerateEntityFooterProps,
} from '@/modules/finance/common/components';

import { useBillsGenerateDisabled } from '../hooks/generate-bills/use-bills-generate-disabled';
import { GenerateBillListItem } from '../types';
import { GenerateBillsTableFormValues } from '../validations';

interface GenerateBillsFooterProps
  extends Omit<GenerateEntityFooterProps, 'isGenerateDisabled' | 'disabledReason'> {
  form: UseFormReturn<GenerateBillsTableFormValues>;
  table: Table<GenerateBillListItem>;
}

/**
 * Footer of the Generate Bills screen. Owns the "can we generate?" validation, which has to watch the
 * whole form: keeping that subscription here means an edit or a newly mounted line re-renders
 * this footer only — not the page and its table.
 */
export const GenerateBillsFooter = ({
  form,
  table,
  selectedItemsCount,
  ...footerProps
}: GenerateBillsFooterProps) => {
  const { isGenerateDisabled, disabledReason } = useBillsGenerateDisabled({
    form,
    table,
    selectedRowsCount: selectedItemsCount,
  });

  return (
    <GenerateEntityFooter
      {...footerProps}
      selectedItemsCount={selectedItemsCount}
      isGenerateDisabled={isGenerateDisabled}
      disabledReason={disabledReason}
    />
  );
};
